import React, { useState } from 'react';
import { flowRight as compose } from 'lodash';
import withStyles from 'isomorphic-style-loader/withStyles';

import ReservationManagement from '../../../components/siteadmin/ReservationManagement';

import reservationsQuery from './reservationsQuery.graphql';

import s from './Reservations.css';
import { withQuery } from '../../../hoc/withGraphql';
function Reservations(props) {
  const { getAllReservations } = props;

  const [state, setState] = useState({
    currentPage: 1,
    searchList: '',
    reservationState: ''
  });

  const changeState = (variables) => setState(prev => ({
    ...prev,
    ...variables
  }));

  return (
    <ReservationManagement
      changeStateValues={changeState}
      currentPage={state.currentPage}
      searchList={state.searchList}
      getAllReservationAdmin={getAllReservations}
      reservationState ={state.reservationState}
    />
  );
}

export default compose(
  withStyles(s),
  withQuery(reservationsQuery, {
    name: 'getAllReservations',
    options: () => ({
      variables: {
        currentPage: 1,
        searchList: '',
        reservationState: ''
      },
      fetchPolicy: 'network-only',
      ssr: false
    })
  })
)(Reservations);